import { useState } from "react";
import { api } from "../lib/api";
import { tokenFromPastedLink } from "../shared/crew-link";

// Paste the link in.
//
// On iPhone the installed app reads a different storage area from Safari, so a
// link tapped in Messages leaves its token behind in Safari and the app opens
// knowing nothing about it. Someone with no crews at least lands somewhere that
// asks for it. Someone who is already in a crew used to land in that crew with
// no way to say "I was trying to open a different one", which is exactly how an
// invite to a second crew disappears.
export function JoinByLink({ label = "Your invite link", cta = "Join the crew" }: { label?: string; cta?: string }) {
  const [link, setLink] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function use() {
    setBusy(true); setErr("");
    const token = tokenFromPastedLink(link);
    if (!token) { setErr("Paste the whole link your friend sent you."); setBusy(false); return; }
    try {
      const r = await api<{ leagueId: string; alreadyMember?: boolean }>(`/api/join`, { body: { token } });
      // A hard navigation on purpose: every screen's data is keyed to the acting
      // crew, and this is a change of crew.
      window.location.href = r.alreadyMember
        ? `/league/${r.leagueId}`
        : `/league/${r.leagueId}/onboarding`;
    } catch (e: any) {
      setErr(e?.message ?? "That link didn't work. Check you copied all of it.");
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <span className="tag">{label}</span>
      <input
        className="input"
        value={link}
        placeholder="Paste the link here"
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        onChange={(e) => setLink(e.target.value)}
      />
      {err && <p className="error">{err}</p>}
      <button className="btn primary" disabled={busy || !link.trim()} onClick={() => void use()}>
        {busy ? "Checking…" : cta}
      </button>
    </div>
  );
}
